import { Link } from "react-router-dom";

export function AuthShell({ title, sub, children, footer }) {
  return (
    <div className="min-h-screen bg-[#FBF9F5] flex flex-col items-center justify-center px-4 py-12">
      <Link to="/" className="mb-8" data-testid="auth-logo">
        <img src="/masaya-logo.png" alt="Masaya Hospitality Cleaning" className="h-16 w-auto" />
      </Link>
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E6DEC3] shadow-[0_10px_40px_rgba(44,38,33,0.08)] p-8">
        <h1 className="font-serif text-3xl text-[#2C2621]">{title}</h1>
        {sub && <p className="mt-2 text-[#635B52]">{sub}</p>}
        <div className="mt-6">{children}</div>
      </div>
      {footer && <div className="mt-6 text-sm text-[#635B52]">{footer}</div>}
    </div>
  );
}

export const inputCls = "mt-1 w-full rounded-xl border border-[#E6DEC3] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#B87333]/30 bg-white";
export const btnCls = "w-full bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-6 py-3 shadow-md transition-all disabled:opacity-60";
